import { render, staticRenderFns } from "./Combos.vue?vue&type=template&id=0fc35b4a&scoped=true&"
import script from "./Combos.vue?vue&type=script&lang=js&"
export * from "./Combos.vue?vue&type=script&lang=js&"
import style0 from "./Combos.vue?vue&type=style&index=0&id=0fc35b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc35b4a",
  null
  
)

component.options.__file = "Combos.vue"
export default component.exports